import { useSelector } from "react-redux";
import { Product } from "../interfaces/Product";
import { StoreState } from "../interfaces/storeState";

export const useProduct = (): Product => useSelector(getProduct);

const getProduct = (state: StoreState): Product => {
  if (!state.product) {
    return {
      productCategory: undefined,
      machineFixingType: undefined,
      toolsProductTypes: undefined,
    };
  }

  return state.product;
};
